import React from 'react';
import { Box, Text, Container, Flex, AspectRatio } from '@chakra-ui/react';
import { CardMedia } from '../CardMedia';

const ContinueReadingEntry = ({ data }) => {
  const { title, subTitle, link } = data;

  return (
    <Box flexBasis={{ base: '50%', md: '25%' }} flexGrow={0} flexShrink={0} p={2}>
      <AspectRatio ratio={1}>
        <CardMedia data={link} />
      </AspectRatio>

      <Text fontSize='lg' fontWeight='bold' mt={5}>
        {title}
      </Text>
      <Text fontSize='sm'>{subTitle}</Text>
    </Box>
  );
};

function ContinueReading({ data, children, rightToLeft }) {
  const { title, subTitle, entries } = data;
  return (
    <Container maxWidth='container.lg' paddingY={10} mb={30} as='section'>
      <Box borderTop='2px' borderStyle='dotted' py={20}>
        <Flex
          direction={{ base: 'column', md: rightToLeft ? 'row-reverse' : 'row' }}
          justifyContent='space-between'
          alignItems='center'
          mb={20}
          gap={10}
        >
          <Box textAlign={rightToLeft ? 'right' : 'left'}>
            <Text as='h3' textStyle='h3'>
              {title}
            </Text>
            <Text>{subTitle}</Text>
          </Box>
          {children}
        </Flex>
        <Flex flexWrap='wrap' margin={-2} textAlign={rightToLeft ? 'right' : 'left'}>
          {entries.map((entry) => (
            <ContinueReadingEntry key={entry._key} data={entry} />
          ))}
        </Flex>
      </Box>
    </Container>
  );
}

export default ContinueReading;
